import http from "@/http-common";

class MenuStationMappingDataService {
  getMenuStationMappingList(): Promise<any> {
    return http.api.post("/getMenuStationMappingList/");
  }
  getRowMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/getRowMenuStationMapping/", data);
  }
  isExistMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/isExistMenuStationMapping/", data);
  }
  getEditMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/getEditMenuStationMapping/", data);
  }
  addMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/addMenuStationMapping/", data);
  }
  editMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/editMenuStationMapping/", data);
  }
  deleteMenuStationMapping(data: any): Promise<any> {
    return http.api.post("/deleteMenuStationMapping/", data);
  }
  getAllMainMenuInfo(data: any): Promise<any>{
    return http.api.post("/getAllMainMenuInfo/", data);
  }
}
export default new MenuStationMappingDataService();